
export default function TestimonialsSection() {
  const testimonials = [
    {
      name: "Sarah M.",
      age: "42",
      treatment: "Weight Loss Program",
      quote: "I lost 35 pounds in 3 months with the GLP-1 program. The medical supervision made me feel safe, and the results speak for themselves. My energy levels are through the roof!",
      rating: 5,
      result: "35 lbs lost in 3 months"
    },
    {
      name: "Michael R.",
      age: "38",
      treatment: "Peptide Therapy",
      quote: "The peptide therapy has completely transformed my recovery time and muscle growth. I feel like I'm in my twenties again. Deborah and her team are incredible.",
      rating: 5,
      result: "Improved recovery & muscle growth"
    },
    {
      name: "Jennifer L.",
      age: "45",
      treatment: "Mental Health Services",
      quote: "After struggling with depression for years, the ketamine therapy has been life-changing. I finally feel like myself again. The holistic approach really works.",
      rating: 5,
      result: "Significant mood improvement"
    },
    {
      name: "David K.",
      age: "52",
      treatment: "IV Therapy & Longevity",
      quote: "The IV treatments and longevity protocols have given me more energy than I've had in decades. My biomarkers have improved dramatically. Highly recommend!",
      rating: 5,
      result: "Increased energy & vitality"
    },
    {
      name: "Lisa T.",
      age: "39",
      treatment: "Hair Growth Treatment",
      quote: "My hair was thinning for years. The peptide-based scalp therapy and PRP treatments have restored my confidence. My hair is thicker and healthier than ever.",
      rating: 5,
      result: "Restored hair thickness"
    },
    {
      name: "Robert H.",
      age: "48",
      treatment: "Comprehensive Wellness",
      quote: "The personalized approach to my health has been amazing. From weight loss to energy optimization, every aspect of my health has improved significantly.",
      rating: 5,
      result: "Overall health transformation"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-black mb-4">
            Real Results from <span className="text-[#8A4F8A]">Real Patients</span>
          </h2>
          <p className="text-xl text-[#B0B0B0] max-w-3xl mx-auto">
            Discover how our patients have transformed their health and lives with our integrative wellness treatments.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-gradient-to-b from-[#F0F0F0] to-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-gradient-to-br from-[#C8A2C8] to-[#8A4F8A] rounded-full flex items-center justify-center mr-4">
                  <i className="ri-user-line text-xl text-white"></i>
                </div>
                <div>
                  <h4 className="font-bold text-black">{testimonial.name}</h4>
                  <p className="text-sm text-[#B0B0B0]">Age {testimonial.age} • {testimonial.treatment}</p>
                </div>
              </div>
              
              <div className="flex mb-3">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#C8A2C8]"></i>
                ))}
              </div>
              
              <blockquote className="text-black mb-4 italic">
                "{testimonial.quote}"
              </blockquote>
              
              <div className="bg-gradient-to-r from-[#C8A2C8] to-[#8A4F8A] rounded-lg p-3">
                <p className="text-sm font-semibold text-white">
                  <i className="ri-trophy-line mr-2"></i>
                  Result: {testimonial.result}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <div className="bg-gradient-to-r from-[#8A4F8A] to-[#C8A2C8] rounded-2xl p-8 text-white">
            <h3 className="text-2xl font-bold mb-4">Join Our Success Stories</h3>
            <p className="text-lg mb-6 opacity-90">
              Ready to experience your own transformation? Start your wellness journey today.
            </p>
            <button className="bg-white text-[#8A4F8A] px-8 py-3 rounded-lg font-semibold hover:bg-[#F0F0F0] transition-colors whitespace-nowrap">
              <i className="ri-calendar-line mr-2"></i>
              Book Your Free Evaluation
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
